import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { authService } from "../services";
import { useAuthStore } from "../store";
import { FiMail, FiLock, FiUser, FiArrowLeft } from "react-icons/fi";

const Register = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    language: "es",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.email ||
      !formData.password ||
      !formData.firstName ||
      !formData.lastName
    ) {
      toast.error(t("errors.fillAllFields"));
      return;
    }

    setLoading(true);
    try {
      const response = await authService.register(formData);
      console.log("Register response:", response);
      const { token, user } = response.data;
      console.log("Token:", token, "User:", user);

      if (!token || !user) {
        throw new Error("Token o usuario no recibidos del servidor");
      }

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      useAuthStore.setState({ user, token });

      toast.success(t("auth.registerSuccess"));

      // Navigate con pequeño delay para asegurar que el estado se actualiza
      setTimeout(() => {
        navigate("/dashboard");
      }, 100);
    } catch (error) {
      console.error("Register error details:", error);
      console.error("Response data:", error.response?.data);
      console.error("Form data sent:", formData);

      let errorMessage = t("errors.serverError");

      if (
        error.response?.data?.errors &&
        Array.isArray(error.response.data.errors)
      ) {
        // Errores de validación - mostrar el primero
        console.log("Validation errors:", error.response.data.errors);
        errorMessage = error.response.data.errors[0]?.msg || errorMessage;
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      console.log("Final error message:", errorMessage);
      toast.error(errorMessage);
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <button
          onClick={() => navigate("/")}
          className="auth-back-button"
          type="button"
        >
          <FiArrowLeft />
          {t("common.back") || "Volver"}
        </button>

        <h2 className="auth-title">{t("auth.registerTitle")}</h2>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label className="form-label">{t("common.firstName")}</label>
            <div className="input-group">
              <FiUser className="input-group-icon" />
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder={t("common.firstName")}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">{t("common.lastName")}</label>
            <div className="input-group">
              <FiUser className="input-group-icon" />
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder={t("common.lastName")}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">{t("common.email")}</label>
            <div className="input-group">
              <FiMail className="input-group-icon" />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t("common.email")}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">{t("common.password")}</label>
            <div className="input-group">
              <FiLock className="input-group-icon" />
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder={t("common.password")}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">{t("common.language")}</label>
            <div className="input-group">
              <select
                name="language"
                value={formData.language}
                onChange={handleChange}
                className="language-selector"
              >
                <option value="en">English</option>
                <option value="es">Español</option>
                <option value="fr">Français</option>
                <option value="de">Deutsch</option>
              </select>
            </div>
          </div>

          <button type="submit" disabled={loading} className="auth-button">
            {loading ? t("common.loading") : t("common.register")}
          </button>
        </form>

        <p className="auth-link">
          {t("auth.haveAccount")}
          <a href="/login">{t("common.login")}</a>
        </p>
      </div>
    </div>
  );
};

export default Register;
